<template>
  <div class="link-module" v-else>
    <img :src="moduleData.img_url" class="link-module-bg">
    <div class="link-imgs">
      <a class="link-img-a" :href="link.link_url" v-for="link in moduleData.links" target="_blank">
        <img :src="link.img_url" class="link-img">
        <div class="link-title" v-if="moduleData.show_title">{{link.link_name}}</div>
      </a>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    moduleData: {
      type: Object
    }
  },
  methods: {
    showModal() {
      this.$emit('consult');
    }
  }
}
</script>

<style lang="less" scoped>
.link-module {
  width: 100%;
  // height: 300px;
  position: relative;
  z-index: 2;
}

.link-module-bg {
  width: 100%;
}

.link-imgs {
  width: 11.8rem;
  // height: 1.5rem;
  position: absolute;
  left: 50%;
  top: 1.1rem;
  transform: translateX(-50%);
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .link-img-a {
    width: 2.8rem;
    // height: 1.7rem;
    cursor: pointer;
    background: #fff;
    display: block;
    text-decoration: none;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.05);

    .link-img {
      width: 2.8rem;
      height: 2.56rem;
      cursor: pointer;
      display: block;
    }

    .link-title {
      width: 100%;
      height: .84rem;
      padding: .2rem .26rem;
      font-size: .17rem;
      line-height: .35rem;
      color: black;
      box-sizing: border-box;
      font-family: "PingFangSC";
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-decoration: none;
    }
  }
  .link-img-a:hover {
    // transform: translateX(5px);
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.4);

    .link-title {
      color: #FBA849;
    }
  }
}

.mobile {
   .link-imgs {
    width: 7rem;
    position: absolute;
    left: 50%;
    top: 1.5rem;
    transform: translateX(-50%);
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-content: space-between;

    .link-img-a {
      width: 3.36rem;
      margin-right: .2rem;
      margin-bottom: .2rem;
    }

    .link-img-a:nth-child(2n) {
      margin-right: 0;
    }
    .link-img-a:nth-last-child(-n + 2) {
      margin-bottom: 0;
    }

    .link-img {
      width: 3.4rem;
      height: 3.08rem;
    }

    .link-title {
      width: 100%;
      height: 1rem;
      padding: .16rem .24rem;
      font-size: .24rem;
      line-height: .32rem;
      color: black;
      box-sizing: border-box;
      font-family: "PingFangSC";
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-decoration: none;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/modules/link-base.vue